<template>
  <div class="prescriptionTable">
    <div class="is-print-hide">
      <div class="btns" v-if="hasBatchApprove">
        <span class="btn-text">当前已选：{{ selectionList.length }}</span>
        <el-button @click="batchApprove">批量处理</el-button>
      </div>
      <div class="btns" v-if="hasBatchDispense">
        <span class="btn-text">当前已选：{{ selectionList.length }}</span>
        <el-button @click="batchDispense">批量处理</el-button>
      </div>
      <div class="btns" v-if="hasBatchDispatch">
        <span class="btn-text">当前已选：{{ selectionList.length }}</span>
        <el-button @click="batchDispatch">批量处理</el-button>
      </div>
      <el-table
        :data="prescriptionList"
        size="medium"
        style="width: 100%"
        :cell-class-name="selectable"
        row-class-name="common-table-row"
        class="common-table"
        @selection-change="selectionChange"
        :border="true"
      >
        <el-table-column v-if="hasSelection" type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="处方编号" min-width="150">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.id + ''" placement="top">
                <el-button class="idbtn" @click="checkDetail(scope.row.id)" type="text" size="small">
                  {{ scope.row.id }}
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="患者姓名" min-width="110">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.name" placement="top">
                <span>{{ scope.row.name }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="storeName" v-if="renderName()" label="提交门店" min-width="110">
          <template slot-scope="scope">
            <el-row>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.storeName" placement="top">
                <div class="storeName_div">{{ scope.row.storeName }}</div>
              </el-tooltip>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="提交人员" min-width="110">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.userName" placement="top">
                <span>{{ scope.row.userName }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="relation" label="关联处方" min-width="110" v-if="listType === 1">
          <template slot-scope="scope" v-if="scope.row.relation">
            <el-button
              v-for="(subId, index) in scope.row.relation.split(',')"
              @click="checkDetail(subId)"
              type="text"
              size="small"
              :key="index"
            >
              {{ subId }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="prescriptionPredistributionAuditorName"
          label="分配药师"
          min-width="80"
        ></el-table-column>
        <el-table-column prop="prescriptionAuditorName" label="审方药师" min-width="80"></el-table-column>
        <el-table-column
          v-if="displayConfigShow(displayConfig.dispense)"
          prop="dispenserSign"
          label="调配"
          min-width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.dispenserSign }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="displayConfigShow(displayConfig.dispatch)"
          prop="dispatcherSign"
          label="发药"
          min-width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.dispatcherSign }}
          </template>
        </el-table-column>
        <el-table-column v-if="tableCommonShow()" prop="auditPlatformName" label="审方平台" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.auditPlatformName ? scope.row.auditPlatformName : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="开方时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.createTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column prop="prescriptionTotalStatus" label="状态" min-width="100">
          <template slot-scope="scope">
            <el-link :underline="false" type="warning">{{ statusText }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="140" fixed="right">
          <template slot="header" slot-scope="scope">
            <div class="hnamecenter">操作</div>
          </template>
          <template slot-scope="scope">
            <el-row>
              <div class="handler">
                <el-button @click="faceRecognitionAndJudgeDrug(scope.row)" type="text">{{ operateBtnText }}</el-button>
              </div>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="`批量操作（已选${selectionList.length}项）`"
      :visible.sync="dialogVisible"
      width="376px"
      destroy-on-close
      @close="dialogVisible = false"
    >
      <div class="body">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="处方操作" prop="accept">
            <el-radio-group v-model="form.accept" @change="changeAccept">
              <el-radio :label="true">通过处方</el-radio>
              <el-radio :label="false">驳回处方</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="驳回原因" v-if="form.accept == false" prop="prescriptionRemark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              placeholder="请输入"
              v-model="form.prescriptionRemark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="primary" style="width: 80px" plain>取 消</el-button>
        <el-button type="primary" @click="submit" style="width: 80px">确 定</el-button>
      </span>
    </el-dialog>
    <sign-pad
      :title="listType == 2 ? `确认调配（已选${selectionList.length}项）` : `确认发药（已选${selectionList.length}项）`"
      :sign-pad-visible="signPadVisible"
      :complete-sign-url="signature"
      @close="signPadVisible = false"
      @submit="confirmAction"
    ></sign-pad>
  </div>
</template>

<script>
import { hasPermission } from '@/util';
import Constant from '@/lib/constant';
import { mapState } from 'vuex';
import signPad from './signPad.vue';
import Fetch from '@/api';

const baseRole = Constant.RoleList;

export default {
  name: 'prescriptionTable',
  components: {
    signPad
  },
  props: {
    prescriptionList: {
      type: Array,
      default: () => []
    },
    listType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selectionList: [],
      dialogVisible: false,
      signPadVisible: false,
      form: {
        accept: null,
        prescriptionRemark: ''
      },
      rules: {
        accept: [
          {
            required: true,
            message: '请选择操作类型',
            trigger: 'change'
          }
        ],
        prescriptionRemark: []
      },
      signature: ''
    };
  },
  computed: {
    displayConfig() {
      return this.$store.getters.getdisplayConfig;
    },
    statusText() {
      const { listType } = this;
      const statusTextMap = {
        1: '待审核',
        2: '待调配',
        3: '待发药'
      };
      return statusTextMap[listType];
    },
    operateBtnText() {
      const { listType } = this;
      const btnTextMap = {
        1: '审核',
        2: '调配',
        3: '发药'
      };
      return btnTextMap[listType];
    },
    hasBatchApprove() {
      return (
        this.listType == 1 && (this.displayConfig.remotePharmacistBatch || this.displayConfig.batchPharmacistAudit)
      );
    },
    hasBatchDispense() {
      return this.listType == 2 && this.displayConfig.batchDispenseDispatch;
    },
    hasBatchDispatch() {
      return this.listType == 3 && this.displayConfig.batchDispenseDispatch;
    },
    hasSelection() {
      return this.hasBatchApprove || this.hasBatchDispense || this.hasBatchDispatch;
    }
  },
  mounted() {
    // this.$alert('批量操作成功，预计3分钟内陆续处理完成，可前往「处方列表」查看处理结果。', '提示', {
    //   confirmButtonText: '确定',
    //   customClass: 'alert_customClass'
    // });
  },
  methods: {
    nextPrescription() {
      if (this.hasBatchApprove) {
        const item = this.prescriptionList[0];
        item && this.faceRecognitionAndJudgeDrug(item);
      }
    },
    changeAccept(v) {
      if (v) {
        this.form.prescriptionRemark = '';
        this.rules.prescriptionRemark = [];
      } else {
        this.rules.prescriptionRemark = [
          {
            required: true,
            message: '请输入驳回原因',
            trigger: 'change'
          }
        ];
      }
    },
    async verify(form) {
      let valid = await this.$refs[form].validate().catch(err => {
        return err;
      });
      return !!valid;
    },
    async submit() {
      const verifyRes = await this.verify('form');
      if (verifyRes) {
        const params = {
          ...this.form,
          source: 'PC',
          idList: this.selectionList.map(el => {
            console.log(el);
            return el.id;
          })
        };
        try {
          await Fetch.verifyPrescription(params);
          this.selectionList = [];
          this.dialogVisible = false;
          await this.$alert('批量操作成功，预计3分钟内陆续处理完成，可前往「处方列表」查看处理结果。', '提示', {
            confirmButtonText: '确定'
          });
          this.$emit('refresh');
        } catch (e) {}
      }
    },
    async confirmAction(data) {
      await Fetch.batchDispenseDispatch({
        signature: data,
        action: this.listType - 1,
        idList: this.selectionList.map(o => o.id)
      });
      this.signPadVisible = false;
      this.$emit('refresh');
    },
    selectionChange(s) {
      this.selectionList = s;
    },
    batchApprove() {
      if (this.selectionList.length > 0) {
        const res = this.selectionList.find(el => {
          return el.faceStatus == 1;
        });
        if (res) {
          import(
            /* webpackChunkName:'punchModal' */
            /* webpackPreload: true */
            '@/pages/punch/components/punchModal'
          ).then(({ default: punchModal }) => {
            punchModal.show({
              success: (image, context) => {
                // todo 人脸识别校验,通过继续药师审方
                return Fetch.face_compare(image).then(({ match }) => {
                  if (match) {
                    context.status = 'recognized';
                    return true;
                  } else {
                    return false;
                  }
                });
              },
              successCallback: () => {
                this.dialogVisible = true;
                this.form.accept = true;
              },
              successDelayDuration: 2000
            });
          });
        } else {
          this.dialogVisible = true;
          this.form.accept = true;
        }
      } else {
        this.$message({
          message: '请先勾选需要处理的处方',
          type: 'warning'
        });
      }
    },
    async batchDispense() {
      if (this.selectionList.length > 0) {
        const { dispenseSignature } = await Fetch.getUserSignature();
        this.signature = dispenseSignature;
        this.signPadVisible = true;
      } else {
        this.$message({
          message: '请先勾选需要处理的处方',
          type: 'warning'
        });
      }
    },
    async batchDispatch() {
      if (this.selectionList.length > 0) {
        const { dispatchSignature } = await Fetch.getUserSignature();
        this.signature = dispatchSignature;
        this.signPadVisible = true;
      } else {
        this.$message({
          message: '请先勾选需要处理的处方',
          type: 'warning'
        });
      }
    },
    displayConfigShow(config) {
      // 调配发药展示逻辑 省局看不到调配发药
      let per = [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f];
      if (hasPermission(per) && config) {
        return true;
      }
    },
    tableCommonShow() {
      // 省局看不到一些项
      let per = [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f];
      if (hasPermission(per)) {
        return true;
      }
    },
    // 1.9.6新增人脸识别校验
    faceRecognitionAndJudgeDrug(data) {
      if (data.faceStatus === 1 && this.listType === 1) {
        import(
          /* webpackChunkName:'punchModal' */
          /* webpackPreload: true */
          '@/pages/punch/components/punchModal'
        ).then(({ default: punchModal }) => {
          punchModal.show({
            success: (image, context) => {
              // todo 人脸识别校验,通过继续药师审方
              return Fetch.face_compare(image).then(({ match }) => {
                if (match) {
                  context.status = 'recognized';
                  return true;
                } else {
                  return false;
                }
              });
            },
            successCallback: () => this.goJudgeDrug(data),
            successDelayDuration: 2000
          });
        });
      } else {
        this.goJudgeDrug(data);
      }
    },
    async goJudgeDrug(data) {
      // 药师处理
      const { id } = data;
      this.$emit('handle', id);
    },
    judgeDrug(data) {
      // 渲染药师审方入口
      if (debug) {
        return true;
      }
      let per = [baseRole.b, baseRole.f];
      if (data.auditable == 1 && hasPermission(per)) {
        return true;
      }
    },
    renderName() {
      // 显示提交门店
      let per = [baseRole.a, baseRole.b, baseRole.c];
      return hasPermission(per);
    },
    checkDetail(id) {
      this.$router.push(`/prescription/detail/${id}?mode=1`);
    },
    selectable({ row }) {
      if (row.prescriptionTotalStatus != 2) {
        return 'unselect';
      }
    }
  }
};
</script>

<style lang="scss">
.unselect .el-checkbox {
  // display: none;
}
body .alert_customClass {
  width: 480px;
}
</style>
<style lang="scss" scoped>
.prescriptionTable {
  .btns {
    margin-bottom: 20px;
    .btn-text {
      margin-right: 24px;
      color: #262626;
      font-size: 12px;
    }
  }
  /deep/.el-dialog {
    padding: 16px 24px 10px;
    .el-dialog__body {
      min-height: 180px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
.handler {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  .btn {
    font-size: 12px;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
}
.digbox {
  img {
    display: block;
    width: 300px;
    margin: 0 auto;
  }
  p {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
  }
}
.hnamecenter {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: center;
}
.idbtn {
  color: #1e8dff !important;

  &:hover {
    text-decoration: underline;
    color: rgba(77, 209, 104, 1) !important;
  }
}
</style>
<style lang="scss" scoped>
.storeName_div {
  // overflow: auto !important;
  // white-space: normal !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.content-wrapper {
  position: relative;
  height: 600px;
  width: 378px;
  .close {
    position: absolute;
    width: 13px;
    height: 13px;
    top: 12px;
    right: 12px;
    z-index: 2;
  }
  .pre-img {
    iframe {
      height: 544px;
      width: 378px;
      border-radius: 4px;
      padding: 24px 24px 0;
    }
    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 16px;
      .contact-store-wrapper {
        margin: 5px 16px 0 0;
      }
    }
  }

  .face-box {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 4px;
    z-index: 1;
    text-align: center;
    .title {
      margin: 144px 49px 48px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: #242424;
      line-height: 24px;
    }
    .btn-box {
      .btn {
        display: block;
        width: 174px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        background: #1e8dff;
        font-size: 14px;
        border-radius: 4px;
        border: 1px solid #1e8dff;
        color: #ffffff;
        &.download {
          margin-top: 16px;
          background: #ffffff;
          color: #1e8dff;
        }
      }
    }
    .download {
      margin-top: 24px;
      .qrcode {
        height: 174px;
        width: 174px;
      }
      .tip {
        margin-top: 8px;
        font-size: 12px;
        color: #707070;
      }
    }
  }
}
</style>
